export default "__VITE_ASSET__CSSBCg8W__"